import React, { useCallback } from 'react';
import { useLocation } from 'wouter';
import { useAppSelector } from '../../hooks';
import { availableUpgradePlans } from '../../selectors';
import { c } from '../../utils';
import { PricingPlan } from '../../components/PricingPlan';
import { Clickable, ClickableVariant } from '../../components/Clickable';

import classes from './StripePricingTable.module.scss';
import { Image } from '../../components/Image';
import { NEW_GATHERLY_ICON } from '../../images';

// [2026-03-07] Replaced the Stripe Pricing Table with a custom pricing page.
// This allows us to manage plans internally and handle subscriptions via Stripe Checkout and the Stripe Billing Portal.
export function StripePricingTable() {
  // Get available upgrade plans from betterDmvAcl (plans collection)
  const plansList = useAppSelector(availableUpgradePlans);

  const [, setLocation] = useLocation();

  const goBackToAccount = useCallback(() => {
    setLocation('/events');
  }, [setLocation]);

  return (
    <div className={c(classes.StripePricingTable)}>
      <Clickable
        variant={ClickableVariant.BUTTON_GRID_INLINE}
        onClick={goBackToAccount}
        label="gatherly icon"
        className={c(classes.GatherlyLogo)}
      >
        <Image src={NEW_GATHERLY_ICON.src} alt={NEW_GATHERLY_ICON.alt} />
      </Clickable>
      <h3 className="color-shade-80 subheading bold">
        Gatherly brings real interaction back
      </h3>
      {/* Display plans available for subscription via Stripe */}
      <div className="flex flex-col md:flex-row gap-2 flex-1 md:justify-center">
        {plansList.map((plan, index) => (
          <PricingPlan key={index} plan={plan} />
        ))}
      </div>
    </div>
  );
}

export default StripePricingTable;
